import { useIsSerialNumberTrackingAvailable } from './use-is-serial-number-tracking-available';
import { useUserHasEditSerialNumbersRole } from '../hooks/use-user-role';

// Sellers without serial number tracking have no serials to protect, so there is nothing here to restrict.
export const useCanEditSerialNumbers = (): boolean => {
  const { isAvailable: isSerialNumberTrackingAvailable } = useIsSerialNumberTrackingAvailable();
  const hasEditSerialNumbersRole = useUserHasEditSerialNumbersRole();
  return !isSerialNumberTrackingAvailable || hasEditSerialNumbersRole;
};
